import oneDspTheme from '../theme/oneDspTheme';

export const activeBackgroundColor = oneDspTheme.palette.primary.light;

export const hoverBackgroundColor = 'f2f2f2'; 
